import { config } from '../config';

// Resolve the latest T&C / Privacy versions a given tenant must have accepted.
export const getLatestDocVersions = (tenant) =>
    config.tenantDocVersions[tenant] || config.defaultDocVersions;

export const determineTenant = () => {
    const host = window.location.hostname.toLowerCase();
    const isLocalHost = host === 'localhost' || host === '127.0.0.1' || host === '::1';

    if (host.indexOf('smithfield') >= 0) {
        return 'smithfield';
    }
    if (
        window.location.origin.toLowerCase().indexOf('investceo') >= 0 ||
        isLocalHost
    ) {
        return 'investceo';
    }
    return 'alm';
}
